@if (!isEmpty(get(logosRow, 'logos', ''))) {
  @for (row of get(logosRow, 'logos.logos', []); track row; let i = $index) {
    <div>
      <section id="rows" class="d-flex flex-row flex-wrap container-padless logos justify-content-center">
        <div class="category-top-title d-flex flex-row justify-content-center pb-2">
          <h2 class="col-md-7 text-center">{{ get(row, 'logos_title', '') }}</h2>
        </div>
        <div class="logo-icon-facets">
          <div class="grid partial-grid container">
            @for (logo of get(row, 'logos', []); track logo) {
              <div
                target="_self"
                [routerLink]="get(logo, 'link.routerLink', '') || null"
                [queryParams]="get(logo, 'link.queryParams', '')"
                class="brand-animation logo g-col-4 g-col-md-2"
                routerLinkActive="brand-animation-disabled"
                >
                @if (get(logo, 'image.href', '')) {
                  <img [src]="getWebpImg(logo.image.href)" [alt]="logo.image.title" />
                }
              </div>
            }
          </div>
        </div>
      </section>
    </div>
  }
}
@if (get(logosRow, 'logos.split_line', '')) {
  <hr class="m-0" />
}
